import * as React from 'react';
import SearchOutlined from '@ant-design/icons/SearchOutlined';
import Input from '../input/Input';
const Search = (props) => {
    const { placeholder = '', value, prefixCls, disabled, onChange, handleClear } = props;
    const handleChange = React.useCallback((e) => {
        if (e.type === 'click') {
            handleClear?.();
        }
        else {
            onChange?.(e);
        }
    }, [onChange, handleClear]);
    return (React.createElement(Input, { placeholder: placeholder, className: prefixCls, value: value, onChange: handleChange, disabled: disabled, allowClear: true, prefix: React.createElement(SearchOutlined, null) }));
};
if (process.env.NODE_ENV !== 'production') {
    Search.displayName = 'Search';
}
export default Search;
